import { Injectable, inject } from '@angular/core';
import { Charge } from '../../../core/models/domain.models';
import { ApiService } from '../../../core/services/api.service';

export interface ChargePayload {
  charge_name: string;
  charge_type: string;
  rate_type?: string | null;
  value: number;
  effective_date: string;
  is_non_refundable: boolean;
  active: boolean;
}

@Injectable({ providedIn: 'root' })
export class ChargesService {
  private readonly api = inject(ApiService);

  list() {
    return this.api.get<Charge[]>('/api/charges');
  }

  create(payload: ChargePayload) {
    return this.api.post<Charge>('/api/charges', payload);
  }

  update(id: string, payload: Partial<ChargePayload>) {
    return this.api.patch<Charge>(`/api/charges/${id}`, payload);
  }

  delete(id: string) {
    return this.api.delete<{ message: string }>(`/api/charges/${id}`);
  }
}
